import { Create, SimpleForm } from 'react-admin';
import { BaseItemEdit } from './BaseItemEdit';

export const ItemCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <BaseItemEdit />
      </SimpleForm>
    </Create>
  );
};
